import BannerComp from "../../components/BannerComp";
import FeatureCard from "../../components/FeatureCard";
import FeatureFlow from "../../components/FeatureFlow";
import FeatureImageContent from "../../components/FeatureImageContent";
import IconBenefitGrid from "../../components/IconBenefitGrid";
import ImageTextSection from "../../components/ImageTextSection";
import Seo from "../../components/Seo";
import { benefitsData, featuresCardData, stepper } from "../../data/minicarm";
import { createBreadcrumbSchema, createWebPageSchema } from "../../lib/seo";

import section1Image from "./minicarm_section1.webp";
import section2Image from "./minicarm_section2.webp";

const seo = {
  title: "Mini C-Arm for Osteoarthritis Injections | MIT4Doctors",
  description:
    "Medical Imaging Tech Services wants to equip providers with top tools. Their goal? Enhance patient results and workflow.",
  schema: [
    createWebPageSchema({
      path: "/services/osteoarthritis-injections",
      title: "Mini C-Arm for Osteoarthritis Injections",
      description:
        "Medical Imaging Tech Services wants to equip providers with top tools. Their goal? Enhance patient results and workflow.",
    }),
    createBreadcrumbSchema(
      "/services/osteoarthritis-injections",
      "Mini C-Arm for Osteoarthritis Injections",
    ),
  ],
};

export default function MiniCArmInjections() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/osteoarthritis-injections"
        schema={seo.schema}
      />
      <BannerComp
        heading="Mini C-Arm for Osteoarthritis Injections"
        paragraph="Medical Imaging Tech Services wants to equip providers with top tools. Their goal? Enhance patient results and workflow."
        centered
        BannerBgImg="/img/banners/miniinjection_hero.webp"
      />

      <ImageTextSection
        image={section1Image}
        imageAlt="Pinpoint Accuracy for Optimal Knee Treatment"
        imagePosition="left"
        title="Pinpoint Accuracy for Optimal Knee Treatment"
        highlightWords="Knee Treatment"
        subSections={[
          {
            heading:
              "Delivering Precision, Safety, and Enhanced Outcomes for Osteoarthritis Patients",
            description:
              "Our advanced Mini C-Arm is designed for osteoarthritis joint injections. It provides pinpoint accuracy and convenience. Plus, it's safe for both patients and providers. This superb technology ensures exact needle position, which improves patient satisfaction and treatment outcomes.",
          },
        ]}
      />

      <FeatureCard
        sectionTitle="Reducing Radiation Exposure with Mini C-Arms"
        sectionDescription="Commitment to Safety and Patient Care Mini C-Arms have transformed patient care. They provide high-precision imaging. But, reducing radiation exposure is a top priority. It protects patients and healthcare staff. Effective safety protocols are essential to safely leveraging the benefits of Mini C-Arms."
        highlightText="Mini C-Arms"
        features={featuresCardData}
      />

      <FeatureImageContent
        heading="Let’s Upgrade Your Practice"
        description="Start delivering osteoarthritis care with the power and precision of Mini C-Arm technology. Contact us to learn how our solution can improve patient outcomes."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Let’s Upgrade Your Practice"
      />

      <IconBenefitGrid
        title="Compact Precision for Specialized Imaging"
        description="Discover compact imaging solutions designed for precise results in specialized practices. Mini C-Arms provide clear, efficient imaging while supporting patient comfort and clinical accuracy."
        highlightWords="Specialized Imaging"
        items={benefitsData}
      />

      <FeatureFlow
        heading="Advantages of Our Mini C-Arm Osteoarthritis Injection"
        highlights={["Osteoarthritis", "Injection"]}
        paragraph="Experience precise results with real-time imaging. It targets pain for lasting relief. Compact and easy to use, it fits any setting. High reimbursement rates make it a good choice."
        steps={stepper}
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="Targeted Relief, Powered by Mini C-Arm"
        imagePosition="left"
        title="Targeted Relief, Powered by Mini C-Arm"
        description="Change the game with our Mini C-Arm. It's perfect for safe, precise joint injections for osteoarthritis. For accurate needle placement. This leads to better results for patients and an increase in their satisfaction. It's small, simple to use, and mindful of radiation. Begin today and offer your patients a focused pain solution and excellent care."
        highlightWords="Mini C-Arm"
      />
    </>
  );
}
